import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const QuickActionMenu = ({ userRole = 'client' }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const quickActions = {
    client: [
      {
        label: 'New Case',
        icon: 'FilePlus',
        path: '/new-case-creation-wizard',
        description: 'Start a new fire forensics case',
      },
      {
        label: 'Find Expert',
        icon: 'Search',
        path: '/expert-marketplace-listing',
        description: 'Browse expert marketplace',
      },
      {
        label: 'View Reports',
        icon: 'FileText',
        path: '/report-viewer',
        description: 'Access completed reports',
      },
    ],
    expert: [
      {
        label: 'Available Cases',
        icon: 'Briefcase',
        path: '/expert-marketplace-listing',
        description: 'View available case assignments',
      },
      {
        label: 'Update Profile',
        icon: 'User',
        path: '/expert-dashboard',
        description: 'Edit expert profile',
      },
    ],
    admin: [
      {
        label: 'Dashboard',
        icon: 'LayoutDashboard',
        path: '/admin-dashboard',
        description: 'View platform analytics',
      },
      {
        label: 'Manage Users',
        icon: 'Users',
        path: '/client-dashboard',
        description: 'User administration',
      },
      {
        label: 'System Settings',
        icon: 'Settings',
        path: '/admin-dashboard',
        description: 'Configure platform',
      },
    ],
  };

  const currentActions = quickActions?.[userRole] || quickActions?.client;

  const handleActionClick = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  return (
    <div className="quick-action-fab">
      <button
        className="w-full h-full flex items-center justify-center"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Quick actions"
        aria-expanded={isOpen}
      >
        <Icon name={isOpen ? 'X' : 'Zap'} size={24} />
      </button>
      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-[40]"
            onClick={() => setIsOpen(false)}
          />
          <div className="quick-action-menu">
            {currentActions?.map((action) => (
              <div
                key={action?.path}
                className="quick-action-item"
                onClick={() => handleActionClick(action?.path)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e?.key === 'Enter' || e?.key === ' ') {
                    handleActionClick(action?.path);
                  }
                }}
              >
                <div className="flex-shrink-0 text-primary">
                  <Icon name={action?.icon} size={20} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm">{action?.label}</div>
                  <div className="caption text-muted-foreground">
                    {action?.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default QuickActionMenu;